import { androidColors, iosColors } from './../../core/services/interface';
import { FontSize } from '@ckeditor/ckeditor5-font';
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { MENU_BUTTON_STYLE, c1 } from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { MenuButton, Tab } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { BuilderService } from 'src/app/sharedservices/builder.service';

@Component({
  selector: "app-button-filler",
  templateUrl: "./button-filler.component.html",
  styleUrls: ["./button-filler.component.scss"],
})
export class ButtonFillerComponent implements OnInit, OnDestroy {

  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    public builderService: BuilderService

  ) { }

  @Input() button: MenuButton;
  @Input() row_id: string;
  @Input() fontSmaller = false;

  @Input() mode: string;
  @Input() fontResize = false;
  @Input() data: Tab;
  @Input() colors: any;
  @Input() no_buttons = 1;

  //////////////////// what have been used //////////////
  currentMenuSubscription: any;
  updateBuilderComponentSubscription: any;
  offCanvasSubscription: any;


  helper: string = null //'Helper Text';
  error: string = null //'error';

  helper_color: string //='#8e8e93'
  error_color: string  //= '#FF0000' ;
  leading_icon: string = null// 'fas fa-heart' ;
  trailing_icon: string = null;   //= 'fas fa-check-circle';
  error_icon: string = 'fas fa-exclamation-circle';
  leading_icon_color: string
  trailing_icon_color: string


  suffix: string;
  suffix_color: string
  prefix: string;
  prefix_color: string;

  border_color: string;
  border_color_ios: string;

  bg_image: string = null;
  bg_color: string;
  start_color: string = null;
  end_color: string = null;
  image: string;
  album_button: any;
  albums: any;
  emptyImage: string;
  emptyImageP0: string;
  emptyImageP1: string;
  widthP0: string;
  label: string;
  sublabel: string;
  label_color: string;
  sublabel_color: string;
  settings: any;
  primary_color: string;
  pStyle: number;
  cellHeight: string;
  labellPadding: string;
  sublabellPadding: string;
  padding: string;
  album_input_map: any;
  labelSetting: any
  sublabelSetting: any

  isAndroid: boolean;
  current_button: any;
  isActive: boolean;
  outline: string;
  label_align: string;
  sublabel_align: string;
  label_size: string;
  sublabel_size: string;
  shadow: boolean;
  outlined: boolean;
  card_round: string;
  sec_round:string;

  divider: number;

  divider_color: string;

  textAlign: any = {};
  textFontsize: any = {};

  border_default_color: string = '#B8B8B8';
  androidColors: any;
  iosColors: any;
  surfaceColor : string;

  /// colors to be common into the tab section///
  light: boolean = true;
  color_schema: any;
  color_schema_ios: any;

  ngOnInit() {

    let style = this.isAndroid ? this.button.button_style : this.button.button_style_ios;
    this.initialize(style, this.no_buttons)

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe((data) => {
      if (data && !data.fromButton) {
        if (data["sortedButtonList"][this.row_id]) {
          this.no_buttons = data["sortedButtonList"][this.row_id].length > 0 ? data["sortedButtonList"][this.row_id].length : 1
          this.current_button = data["currentButton"];
          this.isActive = this.current_button && (this.current_button.button_id == this.button.button_id) ? true : false
          let style = this.isAndroid ? this.button.button_style : this.button.button_style_ios;
         this.initialize(style, this.no_buttons)
        }

        if (data['colors']) {
          this.colors = data["colors"];
          this.light = data["light"];
          this.color_schema = this.light ? this.colors.color_schema.schemes.light : this.colors.color_schema.schemes.dark;
          this.color_schema_ios = this.light ? this.colors.color_schema_ios.schemes.light : this.colors.color_schema_ios.schemes.dark
        }

        let style = this.isAndroid ? this.button.button_style : this.button.button_style_ios;
        this.initialize(style, this.no_buttons)
      }

    })

    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (data && data.button) {
          this.current_button = data.button;
          this.isActive = this.current_button && (this.current_button.button_id == this.button.button_id) ? true : false
          let style = this.isAndroid ? this.button.button_style : this.button.button_style_ios;
          this.initialize(style, this.no_buttons)
        }
      }
    );
  }
  initialize(style, no_button) {
    this.isAndroid = localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
    if (this.colors && this.button) {
      this.color_schema = this.light ? this.colors.color_schema.schemes.light : this.colors.color_schema.schemes.dark;
      this.color_schema_ios = this.light ? this.colors.color_schema_ios.schemes.light : this.colors.color_schema_ios.schemes.dark
      this.image = null
      this.bg_image = null;
      this.start_color = null;
      this.end_color = null;
      this.bg_color = null;


      this.album_button = album_button_map[style];
      this.emptyImage = this.album_button.emptyFullImage[no_button];
      this.card_round =  this.album_button.card_round;
      this.sec_round = this.album_button.sec_round;
      this.border_color = this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'outline', 'outline', this.light);
      this.surfaceColor = this.isAndroid ? this.builderService.buttonColor(null, this.colors.color_schema, null, 'surface', this.light):this.builderService.buttonColor(null, this.colors.color_schema_ios, null, 'surface', this.light)

    }

  }

  get setButtonBg() {
    if (this.bg_image) {
      return {
        "background-image": `url(${this.bg_image})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover",

      };
    }
    else if (this.start_color && this.end_color) {

      return {
        "background-image": `linear-gradient(180deg, ${this.start_color}, ${this.end_color})`,
      };
    } else if (this.bg_color) {
      return { background: this.bg_color };
    } else {

      return { background: this.surfaceColor };
//       return {
//   'background-image': 'none',
//   'background-color': 'transparent'
// };
    }



  }

  get labelColor() {
    return {
      "color": this.label_color,
      'font-size': this.fontSmaller ? '4px' : this.fontResize ? this.no_buttons == 2 ? '10px' : this.no_buttons == 3 ? '8px' : (this.labelSetting && this.labelSetting.titleSize_m) ? this.fontScale('headline', this.labelSetting.titleSize_m) : this.fontScale('headline', '12px') : this.no_buttons == 2 ? '12px' : this.no_buttons == 3 ? '10px' : (this.labelSetting && this.labelSetting.titleSize) ? this.fontScale('headline', this.labelSetting.titleSize) : this.fontScale('headline', '12px'),
    };
  }


  get sublabelColor() {
    return {
      "color": this.sublabel_color,
      'font-size': this.fontSmaller ? '4px' : this.fontResize ? this.no_buttons == 2 ? '6px' : this.no_buttons == 3 ? '4px' : (this.sublabelSetting && this.sublabelSetting.titleSize_m) ? this.fontScale('subhead', this.sublabelSetting.titleSize_m) : this.fontScale('subhead', '12px') : this.no_buttons == 2 ? '6px' : this.no_buttons == 3 ? '4px' : (this.sublabelSetting && this.sublabelSetting.titleSize) ? this.fontScale('subhead', this.sublabelSetting.titleSize) : this.fontScale('subhead', '12px'),
    };
  }




  get helperColor() {
    return {
      "color": this.helper_color ? this.helper_color : '#EBEBEB',
      'font-size': this.fontSmaller ? '2px' : this.no_buttons == 3 ? '8px' : '10px',
    };
  }

  get errorColor() {
    return {
      "color": this.error_color ? this.error_color : '#FF0000',
      'font-size': this.fontSmaller ? '2px' : this.no_buttons == 3 ? '10px' : '12px',
    };
  }


  get leadingIconColor() {
    return {
      "color": this.leading_icon_color ? this.leading_icon_color : '#676767',
      'font-size': this.fontSmaller ? '6px' : this.no_buttons == 2 ? '16px' : this.no_buttons == 3 ? '16px' : this.fontScale('label', '18px'),
    };
  }

  get traillingIconColor() {
    return {
      "color": this.trailing_icon_color ? this.trailing_icon_color : '#676767',
      'font-size': this.fontSmaller ? '4px' : this.no_buttons == 3 ? '14px' : '14px',
    };
  }

  get borderColor() {
    return {

      "border": "solid 1px " + this.borderColor,
      "height": "40px"
    };
  }

  convertStyle (style){
    let cell_style = style[0];
    switch (Number(style[3])){
      case  1:
        // elevated card
        // console.log("I am elevated");
        this.outlined = false;
        this.shadow  = true;
        this.start_color = null;
        this.end_color = null;
        this.bg_color = this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bg', 'surfaceContainerLow', this.light)
       :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bg', 'surfaceContainerLow', this.light) ;
         break;
      case 0:
        // filled card
        // console.log("I am filled");
      this.outlined = false;
      this.shadow  = false
      this.start_color = null;
      this.end_color = null;
       this.bg_color = this.isAndroid ?
       this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bg', 'surfaceContainerHighest', this.light)
      :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bg', 'surfaceContainerHighest', this.light)
      break;

     case 2:
      // console.log("I am outlined");
        // outlined card
        this.outlined = true;
        this.shadow  = false
        this.start_color = null;
        this.end_color = null;
         this.bg_color = this.isAndroid ?
         this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, 'bg', 'surface', this.light)
        :  this.builderService.buttonColor(this.button.button_color_schema_ios, this.colors.color_schema_ios, 'bg', 'surface', this.light)
      break;

      default:
        // console.log("I am else");
      break;


    }
    return cell_style;

}

  // getStyle(style) {
  //   return style
  // }

  fontScale(item, value) {
    let result: number;

    result = value.replace("px", "");

    // large is greater +2 and smaller is less -2
    if (this.textFontsize && this.textFontsize[item]) {

      switch (this.textFontsize[item]) {
        case 'sm':
          result = Number(result) - 2;
          return result + 'px'
          break;
        case 'md':
          return Number(result) + 'px'
          break;
        case 'lg':
          result = Number(result) + 2;
          return result + 'px'
          break;
      }
    } else {
      return value
    }
  }
  ngOnDestroy(): void {
    if (this.updateBuilderComponentSubscription) {
      this.updateBuilderComponentSubscription.unsubscribe();
    }
    if (this.currentMenuSubscription) {
      this.currentMenuSubscription.unsubscribe();
    }

    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
  }


}
export const album_button_map = {
  [MENU_BUTTON_STYLE?.STYLE_01]: {
    emptyFullImage: {
      1: "./assets/images/mobile/splash6.png",
      2: "./assets/images/mobile-2/splash6.png",
      3: "./assets/images/mobile-3/splash6.png",
      4: "./assets/images/mobile-4/splash6.png",
    },
    card_round: null,
    sec_round: null,
  },
}
